module.exports = __webpack_public_path__ + "static/architecting-tomorrow-banking@2x-65fab0eff0320f76ad9b77bde245c53b.jpg";